import { ENTITY_TYPE } from 'src/features/entity/types';
import { membershipMessages } from 'src/features/membership/utils/messages';

export const ENTITY_TYPE_TRANSLATION_MAP = {
    [ENTITY_TYPE.PERSON]: membershipMessages.person,
    [ENTITY_TYPE.ORGANISATION]: membershipMessages.organisation,
};
